import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useDiscountCode } from "./useDiscountCode";
import { DataDiscountCode } from "../../../redux/@types/discountCode";
import {
  deleteDiscountCode,
  discountCodeChangeModalState,
  refreshTableDiscountCode,
  setDiscountCodeForUpdate,
  setIsDiscountCodeForUpdate,
} from "../../../redux/actions/discountCode.actions";
import { notify } from "../../../shared/utils/notify";

const { confirm } = Modal;

export const useTableDiscountCode = () => {
  const dispatch = useAppDispatch();
  const { tableProps } = useDiscountCode();

  const changeDiscountCodeForUpdate = (val: DataDiscountCode) => {
    dispatch(setIsDiscountCodeForUpdate(true));
    dispatch(setDiscountCodeForUpdate(val));
    dispatch(discountCodeChangeModalState());
  };

  const handleDelete = async (valId: number, val: string) => {
    try {
      await deleteDiscountCode(valId);
      dispatch(refreshTableDiscountCode(true));
      notify.success(`Cupón "${val}" eliminado correctamente`);
      tableProps?.refresh();
    } catch (err: any) {
      notify.error(err?.message || "No se pudo eliminar el cupón");
    }
  };

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `¿Eliminar el cupón "${val}"?`,
      icon: <ExclamationCircleOutlined />,
      content:
        "Esta acción no se puede deshacer. El código dejará de estar disponible en la app.",
      okText: "Eliminar cupón",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await handleDelete(valId, val);
      },
      onCancel() {},
    });
  };
  return {
    changeDiscountCodeForUpdate,
    handleDelete,
    showDeleteConfirm,
  };
};
